import './promo.css';

const PromoCard = ({ PromoCode, PromoHeading, Description, DiscAmount, DiscPercentage, onCloseModal }) => {
  return (
    <div className="promo-card">
      <div className="promo-left">
        <div className="promo-text">PROMO</div>
      </div>
      <div className="promo-right">
        <button className="promo-close" onClick={onCloseModal}>
          <i className="bi bi-x"></i>
        </button>
        <div className="promo-content">
          <h3>{Description}</h3>
          <div className="promo-details">
            <div className="promo-code">
              <div className="promo-label">PROMO CODE</div>
              <div className="promo-value">{PromoCode}</div>
            </div>
            <div className="promo-discount">
              <div className="promo-label">DISCOUNT</div>
              <div className="promo-value">
                {DiscPercentage ? `${DiscPercentage}% OFF` : `$${DiscAmount} Rs. OFF`}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PromoCard;